var BASE_API_URL = "";
var REACT_APP_RAZORPAY_KEY_ID = "";

// var isLive = false;  // Local
var isLive = true; // Live

if (isLive) {
  // BASE_API_URL = "https://api.gudfynd.com"; //  Live Api
  REACT_APP_RAZORPAY_KEY_ID = "rzp_live_S63XEWoZshuc9j"; //  Live Key
} else {
  // BASE_API_URL = "https://gydfyndapi.buydirectories.com"; //  Local Api
  REACT_APP_RAZORPAY_KEY_ID = "rzp_test_S63k1RRQCm8niO"; //  Local Key
}

export { BASE_API_URL, REACT_APP_RAZORPAY_KEY_ID };
